<template>

    <div v-if="available">
        <b-link :to="link.to">
            <div v-if="getChildren.length > 0" v-b-toggle="collapseDomId" class="d-flex align-items-center">
                <div class="flex-grow-1">
                    {{ link.title }}
                </div>
                <div class="flex-grow-0">
                    <b-button variant="link" size="sm">
                        <span class="when-closed"><b-icon icon="caret-down-fill"></b-icon></span>
                        <span class="when-open"><b-icon icon="caret-up-fill"></b-icon></span>
                    </b-button>
                </div>
            </div>
            <div v-else>
                <div class="flex-grow-1">
                    {{ link.title }}
                </div>
            </div>
        </b-link>
        <b-collapse :id="collapseDomId" :accordion="childAccordionName">
            <sidebar :links="getChildren" :indent="indent + 1">
            </sidebar>
        </b-collapse>
    </div>

</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        name: "sidebar-link",
        components: {
            Sidebar: () => import('./Sidebar.vue')
        },
        props: {
            link: { type: Object },
            accordion: { type: String },
            indent: { type: Number, default: 0 }
        },
        computed: {
            ...mapGetters(['getRoute']),
            available() { return this.link.hasOwnProperty('available') ? this.link.available : true },
            collapseDomId() {  return this.accordionName + '-' + this.link.name + '-children' },
            accordionName() { return this.accordion ? this.accordion : 'main-menu-accordion' },
            childAccordionName() { return this.accordionName + '-' + this.link.name },
            getChildren() { return this.link.hasOwnProperty('children')? this.link.children : []; }
        },
        methods: {
        }
    };
</script>

<style lang="scss" scoped>
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    div.not-collapsed {
        & .when-open {
            display: block;
        }
        & .when-closed {
            display: none;
        }
    }

    div.collapsed {
        & .when-open {
            display: none;
        }
        & .when-closed {
            display: block;
        }
    }




</style>
